import { render, staticRenderFns } from "./ArrangeIndex.vue?vue&type=template&id=20c1f93b&scoped=true"
import script from "./ArrangeIndex.vue?vue&type=script&lang=js"
export * from "./ArrangeIndex.vue?vue&type=script&lang=js"
import style0 from "./ArrangeIndex.vue?vue&type=style&index=0&id=20c1f93b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c1f93b",
  null
  
)

export default component.exports